import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useSchoolTransactions } from "../../DataStore/FeesTransactionContext";
import ActivityLoader from "../Common/ActivityLoader";
import functions from "../../util/functions";
import DashCardHeader from "../Dashboard/DashCardHeader";

const FeesOverview = ({ currency = "UGX" }) => {
  const { getCollectionOverview, collectionOverview } = useSchoolTransactions();
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    getCollectionOverview();
  }, []);

  // small helper (no decimals, short)
  const fmt = (v) => `${currency} ${functions.numberFormat(v)}`;

  useEffect(() => {
    if (!functions.isObject(collectionOverview)) return;

    const categories = Array.isArray(collectionOverview.class_names)
      ? collectionOverview.class_names
      : [];

    const series = Array.isArray(collectionOverview.data) ? collectionOverview.data : [];

    setChartData({
      series,
      options: {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: { show: false },
          fontFamily: "inherit",
        },

        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: "42%",
            // make stacks look “pill-ish”
            borderRadiusApplication: "end",
            borderRadiusWhenStacked: "all",
          },
        },

        stroke: { show: true, width: 2, colors: ["transparent"] },

        // ✅ Theme palette (no green)
        // Order should match your series order in collectionOverview.data
        colors: [
          "#4F46E5",           // Invoiced
          "rgba(79,70,229,.55)",// Paid (lighter indigo)
          "rgba(79,70,229,.22)" // Discounted (faint indigo)
        ],

        dataLabels: {
          enabled: false, // ✅ remove noisy labels inside bars
        },

        grid: {
          borderColor: "rgba(15,23,42,.08)",
          strokeDashArray: 4,
          padding: { left: 10, right: 10 },
        },

        xaxis: {
          categories,
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: {
            style: { colors: "rgba(71,85,105,.85)", fontSize: "12px", fontWeight: 700 },
          },
          tooltip: { enabled: false },
        },

        yaxis: {
          labels: {
            formatter: (val) => functions.numberFormat(val),
            style: { colors: "rgba(71,85,105,.70)", fontSize: "12px" },
          },
        },

        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: (val) => fmt(val),
          },
        },

        legend: {
          show: true,
          position: "top",
          horizontalAlign: "left",
          fontWeight: 800,
          fontSize: "13px",
          markers: { width: 10, height: 10, radius: 10 },
          itemMargin: { horizontal: 14, vertical: 6 },
          labels: { colors: "rgba(15,23,42,.75)" },
        },

        // Make it feel less “floating”
        fill: { opacity: 1 },

        // Nice top padding so legend doesn’t feel cramped
        responsive: [
          {
            breakpoint: 768,
            options: {
              plotOptions: { bar: { columnWidth: "60%" } },
              legend: { position: "bottom", horizontalAlign: "left" },
            },
          },
        ],
      },
    });
  }, [collectionOverview]);

  return (
    <DashCardHeader title="Fees Collection Overview" description="Invoiced vs Paid vs Discounts by Class" iconClass="fas fa-chart-line">
        {chartData ? (
          <Chart options={chartData.options} series={chartData.series} type="bar" height={300} />
        ) : (
          <ActivityLoader />
        )}
    </DashCardHeader>
  );
};

export default FeesOverview;
